import { FailedToConnectError, HttpError, NotFoundError, PayloadTooLargeError, UnauthorizedError } from '~/errors/errors';
import { TransactionType } from '~/types/Transaction';
import { MagicRequest } from './network/magicRequest';
import { NetworkManager } from './network/networkManager';
export class Gateway {
  protected networkManager: NetworkManager;

  constructor(networkManager: NetworkManager) {
    this.networkManager = networkManager;
  }

  protected sendRequest = async (request: MagicRequest): Promise<Response> => {
    const response = await this.networkManager.sendRequest(request);
    if (response.ok) {
      return response;
    }
    let type: string;
    let message: string;
    try {
      const json = await response
        .clone()
        .json()
        .catch(() => response.clone().text());
      type = json.type || json.errorCode;
      message = json.detail || (Array.isArray(json?.errors?.Reason) ? json.errors.Reason.join(', ') : json?.errors?.Reason || 'unknown');
    } catch {
      type = response.statusText;
      message = 'unknown';
    }
    const statusCode = response.status;
    throw this.createErrorFromResponse(statusCode, message, type);
  };

  protected createCommonHeaders = (): Headers => {
    const headers: Headers = new Headers();
    headers.append('content-type', 'application/json;charset=UTF-8');
    return headers;
  };

  protected getTransactionType(type: string): TransactionType {
    switch (type) {
      case 'payment':
        return TransactionType.Payment;
      case 'return':
        return TransactionType.Return;
      case 'charge':
        return TransactionType.Charge;
      case 'leaseCredit':
        return TransactionType.LeaseCredit;
      default:
        return TransactionType.Unknown;
    }
  }

  private createErrorFromResponse(status: number, message: string, errorType?: string): Error {
    if (status === -1) return new FailedToConnectError();
    if (status === 401) return new UnauthorizedError();
    if (status === 404) {
      return new NotFoundError();
    }
    if (status === 413) {
      return new PayloadTooLargeError();
    }
    return new HttpError(status, message, errorType);
  }
}
